import script from "./Left.vue?vue&type=script&lang=ts"
export * from "./Left.vue?vue&type=script&lang=ts"

import "./Left.vue?vue&type=style&index=0&id=3e075fd4&lang=css"

export default script